import { PropsWithChildren } from 'react';

export const OptionContent = ({
  tagCount,
  withCounter,
  children,
}: PropsWithChildren<{
  tagCount?: number;
  withCounter?: boolean;
}>) => {
  return (
    <div className="text-2xs text-gray-9 group flex h-full items-center">
      <div className="bg-gray-1 group-hover:bg-gray-2 truncate rounded-sm px-2 py-1 leading-none">
        {children}
      </div>
      {withCounter && typeof tagCount === 'number' && (
        <span className="ml-1">{`(${tagCount > 99 ? '+99' : tagCount})`}</span>
      )}
    </div>
  );
};
